import { render } from "./App.vue?vue&type=template&id=173f2a94"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/scss/main.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\Kelvin Rodriguez\\Desktop\\Projects\\digital_cert_ads_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__